import axios from 'axios';
// config
import { HOST_API } from '../config';

// ----------------------------------------------------------------------

// FIXME add global config here, for example by adding the token or userid here
const axiosInstance = axios.create({
  baseURL: HOST_API,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
